import { makeEmptyCaption } from '../util.empty-cation.js';
import { parseImageComponent } from './component.image.js';
import { parseTextComponent } from './component.text.js';
import { parseCaption, parseCaptionDisplayMode } from './util.parse-caption.js';
import { parsePm2Data } from './util.parse-pm2-data.js';

const parseSplitComponent = (node, context) => {
  const caption = parseCaption(node);
  const pm2 = parsePm2Data(node, caption);
  const title = node.getAttribute("title");
  const textNode = parseTextComponent(node, context, {
    textNodeName: "Text",
    elementIconAttributeName: "elementIcon"
  });
  const imageNode = parseImageComponent(node, context);
  if (!pm2 || !textNode || !imageNode) {
    return null;
  }
  const layout = (() => {
    switch (node.getAttribute("imageposition")) {
      case "first":
        return "image-text";
      case "last":
        return "text-image";
      default:
        console.warn(
          "parseSplitComponent(): Failed to parse imageposition correctly",
          node
        );
        return "image-text";
    }
  })();
  return {
    nodeType: "split-component",
    id: void 0,
    pm2,
    options: {
      layout,
      withGraphic: node.getAttribute("graphics") === "true",
      allowCrop: node.getAttribute("imageheight") === "crop"
    },
    text: {
      ...textNode,
      pm2: {
        // Note: We merge relevant fields from the image-node as the
        // TextComponent should display all relevant fields in the
        // ElementToolbar
        ...textNode.pm2,
        transcript: imageNode.pm2.transcript
      },
      options: {
        ...textNode.options,
        displayCaption: true
      },
      meta: {
        ...textNode.meta,
        caption: {
          ...makeEmptyCaption(),
          title: title ? { value: title, showInContext: true, showOutsideContext: true } : void 0
        }
      }
    },
    image: {
      ...imageNode,
      id: void 0,
      pm2: {
        // Note: the text node is responsible for inserting the ElementToolbar
        ...imageNode.pm2,
        learningObjectId: void 0,
        learningObjectTitle: void 0,
        pdfExport: void 0,
        pdfFileUrl: void 0,
        ribbonIconId: void 0,
        speechFileUrl: void 0,
        transcript: void 0
      },
      options: {
        ...imageNode.options,
        displayCaption: parseCaptionDisplayMode(node) ? "below" : void 0
      }
    }
  };
};
const splitComponentParsers = {
  textimage: parseSplitComponent
};

export { splitComponentParsers };
//# sourceMappingURL=component.split.js.map
